import type { MouseEventHandler } from 'react';
import { Button as ButtonComponent } from '@elfsight/widget-ui';
import { getInvertedColor } from '@elfsight/widget-utils';

interface FormAndButtonProps {
  accentColor: string;
  buttonText?: string;
  onClick?: MouseEventHandler;
  isMobile?: boolean;
}

export const Button = ({
  accentColor,
  isMobile,
  buttonText,
  onClick
}: FormAndButtonProps) => {
  return (
    <ButtonComponent
      onClick={onClick}
      fullWidth
      verticalPadding={12}
      lineHeight={1.3}
      color={accentColor}
      fontColor={getInvertedColor(accentColor)}
      font={{
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: isMobile ? 16 : 18
      }}
    >
      {buttonText}
    </ButtonComponent>
  );
};
